<template>
  <div class="infos-forgot-password">
    <div class="step-2" v-if="signSteps.step == 2">
      <span class="forget-title">Esqueci minha senha</span>
      <h4 class="checkout-h4">
        Digite o código de verificação que enviamos para o email
        <span>{{ email }}</span>
      </h4>
      <div class="info-form">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="
            () => {
              /* nunca executar */
            }
          "
        >
          <div class="bt-form" :class="{ 'error-code-form': $v.$error && $v.code.$error }">
            <v-text-field
              ref="code"
              class="btn-codg-complete"
              hide-details
              single-line
              box
              v-model="code"
              pattern="[0-9]*"
              inputmode="numeric"
              :mask="'# # # #'"
              browser-autocomplete="off"
              required
              @keyup.enter="checkCode"
            ></v-text-field>
          </div>
          <v-layout row wrap>
            <v-flex xs12>
              <div
                class="bt-form error-messages mt-2"
                v-show="$v.code.$invalid && code.length == 4"
              >
                <span :key="msg" v-for="msg in errors.code()">{{ msg }}</span>
              </div>
            </v-flex>
          </v-layout>
          <p>
            <link-button :disabled="$v.code.$invalid" class="text-xs-center my-4" @clicked="resendCode">Reenviar código</link-button>
          </p>
          <div class="btn-next-step">
            <v-btn
              block
              round
              depressed
              class="normal-text my-4"
              dark
              :class="$v.code.$invalid ? 'btn-disabled' : ''"
              :color="!$v.code.$invalid ? 'primary' : '#b3d4fc'"
              @click="checkCode"
            >Verificar</v-btn>
            <v-btn
              block
              outline
              round
              class="normal-text mt-4"
              color="primary"
              @click="redirectStep"
            >Entrar com outro email</v-btn>
          </div>
        </v-form>
      </div>
    </div>
    <div class="step-3" v-if="signSteps.step == 3">
      <span class="forget-title">Crie uma nova senha</span>
      <h4 class="checkout-h4">
        Crie uma nova senha para acessar a sua conta com o email {{ email }}. A
        senha deve ter no mínino 6 caracteres.
      </h4>
      <div class="info-form">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="
            () => {
              /* nunca executar */
            }
          "
        >
          <div class="bt-form">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  ref="password"
                  @keyup.enter="changePassword"
                  outline
                  label="Senha"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                  :error-messages="errors.password()"
                  @input="$v.password.$touch()"
                  @blur="$v.password.$touch()"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  ref="confirmPassword"
                  @keyup.enter="changePassword"
                  outline
                  label="Confirmar Senha"
                  :append-icon="
                    showConfirmPassword ? 'visibility' : 'visibility_off'
                  "
                  :type="showConfirmPassword ? 'text' : 'password'"
                  v-model="confirmPassword"
                  :error-messages="errors.confirmPassword()"
                  @input="$v.confirmPassword.$touch()"
                  @blur="$v.confirmPassword.$touch()"
                  @click:append="showConfirmPassword = !showConfirmPassword"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <div class="btn-next-step">
            <v-btn
              block
              round
              depressed
              class="normal-text"
              dark
              :class="$v.$invalid ? 'btn-disabled' : ''"
              :color="!$v.$invalid ? 'primary' : '#b3d4fc'"
              @click="changePassword"
            >Salvar e Entrar</v-btn>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  required,
  sameAs,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators';
import { setTimeout } from 'timers';
import LinkButton from '@/components/UI/LinkButton';

export default {
  components: {
    LinkButton,
  },
  data: vm => ({
    valid: false,
    showPassword: false,
    showConfirmPassword: false,
    password: '',
    confirmPassword: '',
    code: '',
    validCode: true,
  }),
  validations() {
    if (this.signSteps.step === 2) {
      return {
        code: {
          required,
          minLength: minLength(4),
          maxLength: maxLength(4),
          checkCode: () => this.validCode,
        },
      };
    }
    return {
      password: {
        required,
        minLength: minLength(6),
      },
      confirmPassword: {
        required,
        minLength: minLength(6),
        sameAsPassword: sameAs('password'),
      },
    };
  },
  computed: {
    ...mapGetters({
      userProps: 'userProps',
      signSteps: 'signSteps',
    }),
    errors() {
      return {
        code: () => {
          const errors = [];
          !this.$v.code.required && errors.push('Campo obrigatório.');
          !this.$v.code.minLength && errors.push('Código incompleto.');
          !this.$v.code.maxLength && errors.push('Código incompleto.');
          !this.$v.code.checkCode &&
            errors.push('Código Inválido! Confira e digite novamente.');
          return errors;
        },
        password: () => {
          const errors = [];
          if (!this.$v.password.$dirty) return errors;
          !this.$v.password.required && errors.push('Campo obrigatório.');
          !this.$v.password.minLength && errors.push('Mínimo de 6 caracteres');
          return errors;
        },
        confirmPassword: () => {
          const errors = [];
          if (!this.$v.confirmPassword.$dirty) return errors;
          !this.$v.confirmPassword.required &&
            errors.push('Campo obrigatório.');
          !this.$v.password.minLength && errors.push('Mínimo de 6 caracteres');
          !this.$v.confirmPassword.sameAsPassword &&
            errors.push('Senhas não conferem.');
          return errors;
        },
      };
    },
    email: {
      get() {
        return this.userProps.email;
      },
      set(val) {
        this.setUserProps({ ...this.userProps, email: val });
      },
    },
  },
  methods: {
    ...mapActions({
      setUserProps: 'setUserProps',
      setSignSteps: 'setSignSteps',
      emailExists: 'emailExists',
      forgotPassword: 'forgotPassword',
      checkVerificationCode: 'checkVerificationCode',
      setNewPassword: 'setNewPassword',
    }),
    redirectStep () {
      this.$store.dispatch('setCurrentStep', 3);
      this.setSignSteps({ step: 0 });
    },
    setFocus($event, id, next) {
      this.validCode = true;
      this.$refs[`cod${next}`].focus();
      this[id] = $event.key;
    },
    setTokenFocus() {
      this.$refs.code.focus()
    },
    async changePassword() {
      if (this.$v.$invalid === false) {
        try {
          const userPassData = {
            email: this.email,
            token: this.code,
            password: this.password,
          };

          await this.setNewPassword(userPassData);

          this.setSignSteps({ logged: true, signForm: false, step: 0 });
        } catch (error) {
        }
      }
    },
    async resendCode() {
      try {
        // reset
        this.code = '';
        this.validCode = true;

        this.$v.code.$touch();
        this.$v.$reset();

        const { email } = this;
        await this.forgotPassword(email);
      } catch (error) {
      }
    },
    async checkCode() {
      try {
        const { email, code } = this;

        const data = await this.checkVerificationCode({ email, token: code });

        localStorage.setItem('tokenCode', code); // salvando pra resgatar depois

        if (data.success) {
          this.setSignSteps({ step: 3 }); // nova senha
          setTimeout(() => {
            this.$refs.password.focus();
          }, 200);
        }
      } catch (error) {
        if (error.response) {
          // 403

          const { success } = error.response.data;
          if (success === false) {
            this.validCode = false;
            this.$v.$touch();
          }
        }
      }
    },
  },
  watch: {
    code (val) {
      this.validCode = true
    },
    codeBlock(val) {
      this.code = val.join('');
      if (val.length > 1) {
        this.$v.code.$touch();
      }
    }
  },
  mounted() {
    this.code = ''
    this.setTokenFocus()
    if (this.signSteps.step === 3 && (!this.code || this.code.length !== 4)) {
      this.$refs.password.focus();
      this.setSignSteps({ step: 2 });
    }
  },
};
</script>

<style lang="stylus">
@import '~@/assets/infos/forms/infos-forgot-password.styl'
</style>
<style scoped>
.forget-title {
    font-size: 18px;
    font-weight: 500;
    line-height: 23px;
}
.btn-disabled {
  cursor: not-allowed;
  pointer-events: none;
}
</style>
